import React, { useState, useEffect } from "react";
import Images from "./images"; // Import the Images object

// Map each banner image to its college URL
const bannerLinks = [
  { img: Images.AnitsBanner, url: "http://www.anits.edu.in" },
  { img: Images.ChcBanner, url: "http://www.cec.ac.in" },
  { img: Images.GietBanner, url: "https://giet.ac.in/" },
  { img: Images.LendiBanner, url: "https://www.lendi.edu.in/" },
  { img: Images.SrkBanner, url: "https://srkit.in/" },
];

function SponcerBanner({ className = "" }) {
  const [random, setRandom] = useState(null);

  useEffect(() => {
    setRandom(bannerLinks[Math.floor(Math.random() * bannerLinks.length)]);
  }, []);

  if (!random) return null;

  return (
    <div className={`w-full mh-auto mx-auto ${className}`}>
      <a href={random.url} target="_blank" rel="noopener noreferrer">
        <div className="w-full h-full bg-gray-200 border border-gray-300 rounded flex items-center justify-center overflow-hidden">
          <img
            src={random.img}
            alt="Advertisement Banner"
            className="w-full h-full "
          />
        </div>
      </a>
    </div>
  );
}

export default SponcerBanner;
